import React from 'react';
import HeroSection from '../../../components/ProductsDetail/HeroSection';
import ProductShowcaseSection from '../../../components/ProductsDetail/ProductShowcaseSection';
import CTASection from '../../../components/ProductsDetail/CTASection';

// InfoBlocks
import {
  InfoSection,
  InstallGallery,
  FeatureList,
} from '../../../components/ProductsDetail/InfoBlocks';
import SectionDivider from '../../../components/ProductsDetail/SectionDivider';
import ProductDetailNav from '../../../components/ProductsDetail/ProductDetailNav';


const TunnelEntryLight = () => {
  const installColumns = [
    {
      label: '주간',
      images: [
        '/images/products/guardrail/tunnel-entry-light3.webp',
        '/images/products/guardrail/tunnel-entry-light4.webp',
        '/images/products/guardrail/tunnel-entry-light5.webp',
      ],
    },
    {
      label: '야간',
      images: [
        '/images/products/guardrail/tunnel-entry-light7.webp',
        '/images/products/guardrail/tunnel-entry-light2.jpg',
        '/images/products/guardrail/tunnel-entry-light6.jpg',
      ],
    },
  ];

  const features = [
    {
      title: '운전자 안전성 강화',
      bullets: [
      {
        label: (
          <>터널 입구의 시인성을 크게 향상시켜 시야 확보 지원</>
        ),
      },
      {
        label: (
          <>급격한 밝기 변화로 인한 ‘블랙홀·화이트홀 현상’ 완화</>
        ),
      },
      {
        label: (
          <>터널 진입 시 시야 적응 시간을 줄여 사고 위험 감소</>
        ),
      },
      ]
    },
    {
      title: '고효율·고성능 LED 적용',
      bullets: [
      {
        label: (
          <>에너지 효율이 높은 LED 광원을 사용하여 운영비 절감</>
        ),
      },
      {
        label: (
          <>장수명 광원 적용으로 교체 주기 감소 및 유지관리 비용 절감</>
        ),
      },
      {
        label: (
          <>색온도 및 광량을 균일하게 유지해 야간·악천후에서도 안정적인 조도 제공</>
        ),
      },
      ]
    },
    {
      title: '내구성과 신뢰성이 강화된 구조',
      bullets: [
      {
        label: (
          <>혹독한 터널 환경(먼지, 진동, 온도 변화)에 견딜 수 있는 견고한 설계</>
        ),
      },
      {
        label: (
          <>방수·방진 등급을 확보해 장기간 안정적인 사용 가능</>
        ),
      },
      {
        label: (
          <>노면 및 주변 구조물과의 간섭을 최소화한 최적의 설치 구조</>
        ),
      },
      ]
    },
    {
      title: '설치 및 유지보수 편의성',
      bullets: [
      {
        label: (
          <>현장 조건에 맞춘 다양한 설치 방식 제공</>
        ),
      },
      {
        label: (
          <>모듈형 구조로 점검 및 부품 교체가 용이</>
        ),
      },
      {
        label: (
          <>유지보수 인력의 안전성과 접근성을 고려한 시스템 설계</>
        ),
      },
      ]
    },
  ];

  

  return (
    <>
      <HeroSection
        title={`터널입구 조명시설`}
        subtitle={`터널 입·출구 안전사고 위험을 예방합니다`}
        backgroundImage="/images/products/guardrail/tunnel-entry-light7.webp"
        breadcrumbs={[
          { label: '홈', path: '/' },
          { label: '도로 안전유도시설', path: '/products/guardrail' },
          { label: '터널입구 조명시설' },
        ]}
        categories={[
          { label: '도로 안전경보시스템', path: '/products/traffic-safety' },
          { label: '도로 안전유도시설', path: '/products/guardrail' },
          { label: '도로환경 개선시설', path: '/products/facilities' },
          { label: '도로 안내표지시스템', path: '/products/signage' },
        ]}
      />

      <ProductShowcaseSection
        subtitle={`고효율 LED 기반 안전 조명 시스템`}
        title={`터널입구 조명시설`}
        description={
          <>
            터널 진입 구간에 설치되는 <strong>고효율 LED 기반 안전 조명 시스템</strong>으로, {' '}
            운전자의 시야 확보와 시인성 향상을 통해 <strong>터널 입·출구에서 발생하는 시각적 불균형과 안전사고 위험을 효과적으로 낮추는 역할</strong>을 수행합니다.
            <br />
            <br />
            다양한 도로 환경에서 안정적이고 균일한 광량을 제공하며, 에너지 절감과 유지관리 효율성을 갖추고 있습니다.

          </>
        }
        images={[
          '/images/products/guardrail/tunnel-entry-light2.jpg',
          '/images/products/guardrail/tunnel-entry-light7.webp',
          '/images/products/guardrail/tunnel-entry-light6.jpg',
        ]}
      />

      <SectionDivider />

      <InfoSection title="설치 사진">
        <InstallGallery columns={installColumns} />
      </InfoSection>


      <InfoSection title="제품 특징">
        <FeatureList features={features} />
      </InfoSection>

      <ProductDetailNav
        category="guardrail"
        currentPath="/products/guardrail/tunnel-entry-light"
        listPath="/products/guardrail"
      />


      <CTASection />
    </>
  );
};

export default TunnelEntryLight;
